// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)
import App from './App'
import router from './router'

Vue.config.productionTip = false;
// 全局引入Toast
import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
Vue.use(Toast);

import VueLazyload from "vue-lazyload";
Vue.use(VueLazyload,{
  preLoad: 1.3,
  attempt: 3
});





//按照宽度750图算， 1rem = 100px;
(function (win, doc) {
  // 字体变化
  function changeSize() {
    doc.documentElement.style.fontSize = doc.documentElement.clientWidth / 7.5 + 'px';
  }
  changeSize();
  win.addEventListener('resize', changeSize, false);

  function aplusQueueFn(i) {
    // 友盟+ H5打点
    win['aplus_queue'] = win['aplus_queue'] || [];
    var f = doc.getElementsByTagName('script')[0],
      j = doc.createElement('script');
    j.async = true;
    j.id = 'beacon-aplus';
    j.src = 'https://d.alicdn.com/alilog/mlog/aplus/' + i + '.js';
    f.parentNode.insertBefore(j, f);
  }

  function aplusQueuePush(appKey) {
    //集成应用的appKey
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['appKey', appKey]
    });
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-waiting', 'MAN']
    });
    aplus_queue.push({
      action: 'aplus.setMetaInfo',
      arguments: ['DEBUG', false]
    });
  }

  function volcanoInit(app_id,userId) { 
        window.collectEvent('init', {
          app_id,//  必须替换成申请的 app_id
          channel: 'cn', //数据发送地址
          log: true, // 开启调试日志
          enable_ab_test: true, // boolean类型，是否开启A/B实验功能
          autotrack: false // 开启全埋点采集，默认关闭，需要热力图及圈选功能可开启
        });
    
      if(userId) { 
        window.collectEvent('config', { 
          user_unique_id: userId  //设置唯一用户ID 
        });
      }
      // 这里可以添加设置用户 id，自定义事件，设置公共属性的代码
      window.collectEvent('start'); //通知 SDK 所有设置已经完备，可以真正开始发送事件了。
  }

  // 

  // app传参
  win.setRefundFn = async function (obj) {
    // alert(JSON.stringify(obj))
    let isJson = isJSON(obj);
    isJson && (obj = JSON.parse(obj))
    // await aplusQueueFn('203467608')
    if (obj.bundleId == "com.youme.he_year") {
      localStorage.setItem('appName', "你我他当年");
    } else if (obj.bundleId == "com.example.light_year") {
      localStorage.setItem('appName', "时空光年");
    } else if (obj.bundleId == "com.example.zqyears_java") {
      localStorage.setItem('appName', "照片修复大全");
    } else if (obj.bundleId == "com.ws.identifier.card.flutter_identifier_card") {
      localStorage.setItem('appName', "证件照全能王");
    } else if (obj.bundleId == "com.ws.woktile.fast.fix.old.pic") {
      localStorage.setItem('appName', "修复老照片");
    } else if (obj.bundleId == 'com.android.aidraw.viva') {
      localStorage.setItem('appName', "VIVA");
    }
    localStorage.setItem('token',obj.token)
    localStorage.setItem('userId',obj.userId)
    $addStorageEvent("bundleId", obj.bundleId)
  }

  if(win.webkit && win.webkit.messageHandlers) {
    // Ios 客户端调用方法
    win.webkit.messageHandlers.setRefundFn.postMessage(null);
  }

  // setTimeout(() => { 
  //   if (!localStorage.getItem("bundleId")) {
  //     // 正式token
  //     // 6R+k6AlRkBdNNZuNT6rBXNus96laVZKXronaSHhHgpDpIz32PgDJ4PLpuzGu29UqzCzhHMl5eZA=
  //     // 测试token
  //     // oVS1OQRjjJifIUUCSlR/BxKgLpksvUpcnMykjsC3iErkEWFFHJRLQQ==
  //     setRefundFn({"bundleId":"com.youme.he_year","userId":"109781","token":'oVS1OQRjjJifIUUCSlR/BxKgLpksvUpcnMykjsC3iErkEWFFHJRLQQ=='})
  //   }
  // },1000)

  // 监听 派发事件
  function $addStorageEvent(key, data) {
    var newStorageEvent = document.createEvent('StorageEvent');
    const storage = {
      setItem: function (key, val) {
        localStorage.setItem(key, val);
        // 初始化创建事件
        newStorageEvent.initStorageEvent('setItem', false, false, key, null, val, null, null);
        // 派发对象
        window.dispatchEvent(newStorageEvent);
      }
    }
    return storage.setItem(key, data)
  }

  // 判断是否为json格式
  function isJSON(str) {
    if (typeof str == 'string') {
      try {
        var obj = JSON.parse(str);
        if (typeof obj == 'object' && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    }
  }
})(window, document);


// 友盟+ HTML5 打点
Vue.prototype.addAplusQueue = function(o) {
	let aplus_queue = window.aplus_queue || []
  aplus_queue.push({
    action: 'aplus.record',
    arguments: [o.key, "CLK", {
      param: o.val
    }]
  });
}

// 火山埋点
Vue.prototype.collectEvent = function (o) {
  window.collectEvent(o.key, {
    action: o.action
 });
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js